import React, {Component} from 'react';
import {client} from '../../Client';
import TableFilter from '../TableFilter'
import CommesseSelectTable from './CommesseSelectTable'
import CommessaStatoSelect from './CommessaStatoSelect'
import ErrorMessage from '../ErrorMessage'
import PropTypes from 'prop-types';
class CommessaSelectList extends Component {
    constructor(props) {
        super(props);
        this.state = {
            rowperpage: 20,
            items:[],
            total:0,
            page:1,
            _loading: false,
            error: null,
            orderInfo: [
                {field: 'priorita', direction: 'A'},
                {field: 'nome', direction: 'A'},
            ],
            filterInfo: {isChiusa: false, isArchiviata: false},
        };
        this.onChangeFilter = this.onChangeFilter.bind(this)
        this.onChangeCommessaStato = this.onChangeCommessaStato.bind(this)
        this.onChangePage = this.onChangePage.bind(this)
        this.onCommessaSelect = this.onCommessaSelect.bind(this)
        this.loadData = this.loadData.bind(this)
    }

    onChangeFilter(data){
        let newFilterInfo = {
            keyword: data.keyword,
            isChiusa: this.state.filterInfo.isChiusa,
            isArchiviata: this.state.filterInfo.isArchiviata,
        };
        this.loadData(1, this.state.orderInfo, newFilterInfo)
    }

    componentDidMount() {
        this.loadData(1, this.state.orderInfo, this.state.filterInfo)
    }

    onChangePage(newpage) {
        this.loadData(newpage, this.state.orderInfo, this.state.filterInfo)
    }

    onCommessaSelect(commessa){
        this.props.onChange(commessa);
    }

    onChangeCommessaStato(isChiusa, isArchiviata){
        let newFilterInfo = {
            keyword: this.state.filterInfo.keyword,
            isChiusa,
            isArchiviata
        };
        this.loadData(1, this.state.orderInfo, newFilterInfo);
    }


    loadData(page, orderInfo, filterInfo) {
        this.setState({_loading: true});
        client.loadCommesseList(
            this.state.rowperpage,
            page,
            orderInfo,
            filterInfo
        ).then((response) => {
            if (response.ok)
            {
                response.json().then((data)=>{
                    this.setState({
                        items: data.items,
                        total: data.total,
                        page: page,
                        filterInfo: filterInfo,
                        _loading: false,
                        error: null
                    })
                })
            }
            else if (response.status === 401)
            {
                this.context.router.transitionTo("/login")
            }
            else
            {
                response.json().then((data) => {
                    this.setState({
                        _loading: false,
                        error: {title: data.title, msg: data.msg}
                    })
                })
            }
        }).catch((error) => {
            this.setState({
                _loading: false,
                error: {title: "Errore di rete imprevisto", msg: error.message}
            })
        });
    }

    render() {

        if (this.state.error !== null)
        {
            return (<ErrorMessage title={this.state.error.title} msg={this.state.error.msg} onDismiss={()=>{this.setState({error:null})}}/>)
        }
        let loader = '';
        if  (this.state._loading) {
            loader = (
                <div className="ui active inverted dimmer">
                    <div className="ui loader"></div>
                </div>
            );
        }
        let cardClassName = this.props.fluid ? "ui fluid card" : "ui card";
        return (<div className={cardClassName}> <div className="content">

            <TableFilter
                value={this.state.filterInfo.keyword}
                placeholder="Filtra commessa per nome o codice..."
                onChangeFilter={this.onChangeFilter} />
            <CommessaStatoSelect
                isChiusa={this.state.filterInfo.isChiusa}
                isArchiviata={this.state.filterInfo.isArchiviata}
                onChange={this.onChangeCommessaStato}
            />
            <CommesseSelectTable
                items={this.state.items}
                count={this.state.total}
                page={this.state.page}
                rowperpage={this.state.rowperpage}
                onChangePage={this.onChangePage}
                onCommessaSelect={this.onCommessaSelect}
            />
        </div>
            {loader}
        </div>)
    }
}

CommessaSelectList.PropTypes = {
    onChange: PropTypes.func.isRequired,
    fluid: PropTypes.bool.isRequired,
    compact: PropTypes.bool.isRequired,
}

CommessaSelectList.defaultProps = {
    fluid: false,
    compact: false
};


CommessaSelectList.contextTypes = {
    router: PropTypes.object
}

export default CommessaSelectList;




/** WEBPACK FOOTER **
 ** ./src/components/commesse/CommessaSelectList.js
 **/